import { createSelector } from 'reselect';

import { initialState } from '../../reducer';

const globalState = state => state.global || initialState;

const selectAuthorsMap = () => createSelector(globalState, dataState => dataState.get('authors'));

export { selectAuthorsMap };
